import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, } from 'recharts';
function CustomToolTip({ refreshInterval, active, payload, label }) {
    const intl = useIntl();
    const theme = useTheme();
    if (!active || !payload) {
        return null;
    }
    return (React.createElement(Stack, { sx: { background: theme.palette.background.paper, opacity: 0.8, padding: 1 } },
        React.createElement(Typography, { variant: "caption", sx: { lineHeight: '1rem' } }, intl.formatDateTimeRange(label, label + refreshInterval, {
            dateStyle: 'long',
            timeStyle: 'short',
        })),
        React.createElement(Typography, { variant: "caption", color: payload.length > 0 ? payload[0].color : theme.palette.divider, sx: { lineHeight: '1rem' } },
            'Ground speed : ',
            payload.length > 0 && payload[0].value
                ? parseFloat(payload[0].value.toString() || '0').toFixed(2) + ' \u33B7'
                : '-'),
        React.createElement(Typography, { variant: "caption", color: payload.length > 1 ? payload[1].color : theme.palette.action.disabled, sx: { lineHeight: '1rem' } },
            'Air speed : ',
            payload.length > 1 && payload[1].value
                ? parseFloat(payload[1].value.toString() || '0').toFixed(2) + ' dA'
                : '-')));
}
function SpeedChart({ data, refreshInterval }) {
    const theme = useTheme();
    if (!data || data.length <= 0) {
        return React.createElement(Typography, { variant: "body2" }, "No data.");
    }
    return (React.createElement(ResponsiveContainer, null,
        React.createElement(LineChart, { data: data },
            React.createElement(Tooltip, { content: React.createElement(CustomToolTip, { refreshInterval: refreshInterval }) }),
            React.createElement(CartesianGrid, { strokeDasharray: 3 }),
            React.createElement(XAxis, { dataKey: "time", hide: true }),
            React.createElement(YAxis, { axisLine: false, tick: { fontSize: 10 }, width: 20, domain: ['auto', 'auto'] }),
            React.createElement(Line, { type: "monotone", name: "Ground speed", dataKey: "groundSpeed", stroke: theme.palette.info.light, dot: false }),
            React.createElement(Line, { type: "monotone", name: "Air speed", dataKey: "airSpeed", stroke: theme.palette.error.light, dot: false }),
            React.createElement(Legend, { wrapperStyle: { fontSize: '0.75rem' } }))));
}
export default React.memo(SpeedChart);
